export default __webpack_public_path__ + "static/media/img-clients_1.1a54dc34.png";